import React from 'react';
import { SaveState } from '../types';

interface StateIndicatorProps {
  state: SaveState;
  errorMessage?: string;
}

export function StateIndicator({ state, errorMessage }: StateIndicatorProps) {
  const getTitle = () => {
    switch (state) {
      case 'saving':
        return "Salvando Arquivo...";
      case 'error':
        return "Erro ao Salvar Arquivo";
      default:
        return "Arquivo Salvo com Sucesso!";
    }
  };

  const getStatusMessage = () => {
    if (state === 'error') {
      return (
        <p className="text-center text-red-400 text-sm mb-2">
          {errorMessage || "Ocorreu um erro durante o salvamento"}
        </p>
      );
    }

    if (state === 'success') {
      return (
        <p className="text-center text-emerald-400 text-sm mb-2">
          Processo concluído com sucesso!
        </p>
      );
    }

    return null;
  };

  return (
    <div className="flex flex-col space-y-1">
      <h3 className="text-sm font-bold text-white leading-tight">
        {getTitle()}
      </h3>
      {getStatusMessage() && (
        <div className="text-xs text-emerald-400 font-medium">
          Processo concluído com sucesso!
        </div>
      )}
    </div>
  );
}